/**
 * MessageRouterLead - Router for lead-specific messages (/leads/:id/messages)
 */

import React from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';

import { MessageDetailsPage, MessageListPage } from './components';
import { MessageProvider } from './context';

function MessageRouterLead(props) {
  const { path } = useRouteMatch();

  return (
    <MessageProvider {...props} isFromLead caseDetails={props.leadDetails}>
      <Switch>
        <Route exact path={path} component={MessageListPage} />
        <Route path={`${path}/:message_id`} component={MessageDetailsPage} />
      </Switch>
    </MessageProvider>
  );
}

export default MessageRouterLead;
